import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'validate.js';

import CardBadge from 'dpl/breeder_search_results/mobile/components/CardBadge';
import ClickableDiv from 'dpl/common/components/ClickableDiv';
import SmartImage from 'dpl/components/SmartImage';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURES
} from 'dpl/constants/analytics';
import { BADGE_POSITIONS } from 'dpl/puppy_search_results/utils/constants';
import { isMobileUA } from 'dpl/shared/utils';
import { sendAnalyticsEvent, sendRudderstackEvent } from 'dpl/util/analytics';

const IS_MOBILE = isMobileUA();

const imageMediaFileDefaultPropAnalytics = {};
/** @param {any} props */
export default function ImageMediaFile({
  badgeProps = null,
  mediaFile,
  smartImageProps,
  analytics = imageMediaFileDefaultPropAnalytics,
  carouselPosition = null
}) {
  const {
    alt,
    analytics: imageAnalytics,
    experiment_clickthrough_url: clickthroughUrl,
    url
  } = mediaFile;

  const puppyId = mediaFile.puppy_id || null;

  function handleImageClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (imageAnalytics) {
      sendAnalyticsEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, imageAnalytics);
    }

    if (puppyId) {
      sendRudderstackEvent(ANALYTICS_EVENTS.CARD_CLICKED_BY_USER, {
        ...analytics,
        view_feature: ANALYTICS_VIEW_FEATURES.PUPPY_PHOTO,
        dog_id: puppyId,
        carousel_position: carouselPosition
      });
      if (IS_MOBILE) {
        window.location.href = clickthroughUrl;
      } else {
        window.open(clickthroughUrl, '_blank', 'noopener');
      }
    } else {
      sendRudderstackEvent(ANALYTICS_EVENTS.CARD_CLICKED_BY_USER, analytics);
      if (IS_MOBILE) {
        window.location.href = clickthroughUrl;
      } else {
        window.open(clickthroughUrl, '_blank', 'noopener');
      }
    }
  }

  const isClickable = Boolean(puppyId || clickthroughUrl);
  const Component = isClickable ? ClickableDiv : 'div';

  return (
    <Component
      data-test-id={`card-media-carousel-image-${mediaFile.id}`}
      className="ImageMediaFile h-100 db relative"
      {...(isClickable && {
        style: { width: smartImageProps.width },
        onClick: handleImageClick
      })}
    >
      <SmartImage {...smartImageProps} alt={alt} src={url} />
      {!isEmpty(badgeProps) && (
        <div
          className={classnames(
            'badge_container absolute absolute--fill pointer-events-none pv2 ph2',
            {
              'flex items-end': badgeProps.position === BADGE_POSITIONS.BOTTOM
            }
          )}
        >
          <CardBadge className="pv1 pv2-md ph2 ph3-md">
            {badgeProps.text}
          </CardBadge>
        </div>
      )}
    </Component>
  );
}
ImageMediaFile.propTypes = {
  mediaFile: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    analytics: PropTypes.shape({
      view: PropTypes.string.isRequired,
      view_feature: PropTypes.string.isRequired,
      view_feature_location: PropTypes.string.isRequired
    }),
    url: PropTypes.string,
    alt: PropTypes.string,
    experiment_clickthrough_url: PropTypes.string,
    playback_ids: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        policy: PropTypes.string.isRequired
      })
    ),
    status: PropTypes.string,
    aspect_ratio: PropTypes.string,
    type: PropTypes.string,
    puppy_id: PropTypes.number
  }).isRequired,
  analytics: PropTypes.shape({
    availability: PropTypes.string,
    breed_id: PropTypes.number,
    breeder_profile_id: PropTypes.number,
    position: PropTypes.number,
    view: PropTypes.string.isRequired,
    view_feature: PropTypes.string,
    view_feature_location: PropTypes.string.isRequired
  }),
  // eslint-disable-next-line react/forbid-prop-types
  smartImageProps: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  muxRef: PropTypes.object,
  badgeProps: PropTypes.shape({
    text: PropTypes.string.isRequired,
    position: PropTypes.string
  }),
  carouselPosition: PropTypes.number
};
